export default function () {
  if (this.$route.params.orderId) {
    this.searchParams['payable.order.id'] = this.$route.params.orderId
  }
  this.loadTransfers();
}
